/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
import React from 'react';
import { Typography } from '@material-ui/core';
import { lowerFirstLetter } from '../../../utils/helpers';
import _ from '../../../utils/lodash';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['EventType', 'EventType', 'CreatedDate', 'UserLogin'];
  const dtoNames = ['eventType', 'eventDescription', 'createdDate', 'userLogin'];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

const mapRowData = (rowData, eventHandlers) => {
  const result = {
    entryId: rowData[0],
    type: rowData[1],
    dateCreated: rowData[3],
    user: rowData[4],
    description: rowData[5],
    properties: rowData[6],
  };
  eventHandlers.handleSidePanel(true, result);
};

export const tableSettings = options => {
  const eventHandlers = options.eventHandlers;
  const locale = eventHandlers.locale;
  const moment = eventHandlers.moment;

  const generateDescription = (descriptionKey, parameters) => {
    return eventHandlers.generateDescription(descriptionKey, parameters);
  };

  return {
    name: <Typography variant="h3">Audit</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'eventType',
        label: locale.getMsg('eventType'),
        options: {
          sort: true,
          sortOrder: {
            name: 'eventType',
            direction: setSortDirection('eventType', options),
          },
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
          customBodyRender: value => {
            return eventHandlers.eventTypeLocale.getMsg(lowerFirstLetter(value));
          },
        },
      },
      {
        name: 'eventDescription',
        label: locale.getMsg('eventDescription'),
        options: {
          sort: true,
          sortOrder: {
            name: 'eventDescription',
            direction: setSortDirection('eventDescription', options),
          },
          setCellProps: () => ({
            style: { minWidth: 400 },
          }),
          customBodyRender: (value, tableMeta) => {
            return (
              <span>{tableMeta.rowData[5] ? generateDescription(tableMeta.rowData[5], tableMeta.rowData[6]) : ''}</span>
            );
          },
        },
      },
      {
        name: 'createdDate',
        label: locale.getMsg('createdDate'),
        options: {
          sort: true,
          sortOrder: {
            name: 'createdDate',
            direction: setSortDirection('createdDate', options),
          },
          setCellProps: () => ({
            style: { width: 200 },
          }),
          customBodyRender: value => (value ? moment(value).format(eventHandlers.dateFormats) : ''),
        },
      },
      {
        name: 'userLogin',
        label: locale.getMsg('user'),
        options: {
          sort: true,
          sortOrder: {
            name: 'userLogin',
            direction: setSortDirection('userLogin', options),
          },
          setCellProps: () => ({
            style: { width: 100 },
          }),
        },
      },
      {
        name: 'descriptionTranslationKey',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'parameters',
        options: {
          display: 'excluded',
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      onRowClick: rowData => mapRowData(rowData, eventHandlers),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
